import { render, staticRenderFns } from "./suppliers.vue?vue&type=template&id=86718ff8"
import script from "./suppliers.vue?vue&type=script&lang=js"
export * from "./suppliers.vue?vue&type=script&lang=js"
import style0 from "./suppliers.vue?vue&type=style&index=0&id=86718ff8&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/Resourced/Resourced/Frontend-old/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('86718ff8')) {
      api.createRecord('86718ff8', component.options)
    } else {
      api.reload('86718ff8', component.options)
    }
    module.hot.accept("./suppliers.vue?vue&type=template&id=86718ff8", function () {
      api.rerender('86718ff8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/pages/suppliers.vue"
export default component.exports